import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../utils/api';
import { styles, colors } from '../../styles/globalStyles';

export const AtivacaoConta = ({ onSuccess, onCancel }) => {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [validando, setValidando] = useState(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      validarToken(tokenFromUrl);
    }
  }, []);

  const validarToken = async (token) => {
    setValidando(true);
    setError('');
    try {
      const response = await axios.get(`${API_URL}/ativar-conta/${token}`);
      setUser(response.data.user);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Token inválido ou expirado');
      setLoading(false);
    } finally {
      setValidando(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await axios.post(`${API_URL}/ativar-conta/${token}`, { password });
      
      setSuccess(true);
      setTimeout(() => {
        if (onSuccess) onSuccess();
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao definir senha');
    } finally {
      setLoading(false);
    }
  };

  if (validando || loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`
      }}>
        <div style={{
          backgroundColor: colors.white,
          padding: '3rem',
          borderRadius: '1.5rem',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            border: '3px solid #e2e8f0',
            borderTopColor: colors.primary,
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1.5rem'
          }}></div>
          <h2 style={{ color: colors.dark, marginBottom: '0.5rem' }}>
            Validando...
          </h2>
          <p style={{ color: colors.gray }}>
            Aguarde enquanto validamos seu token
          </p>
        </div>
      </div>
    );
  }

  if (error && !user) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`
      }}>
        <div style={{
          backgroundColor: colors.white,
          padding: '3rem',
          borderRadius: '1.5rem',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            backgroundColor: '#fee2e2',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem',
            fontSize: '1.5rem'
          }}>
            ❌
          </div>
          <h2 style={{ color: colors.dark, marginBottom: '0.5rem' }}>
            Erro na Ativação
          </h2>
          <p style={{ color: colors.danger, marginBottom: '1.5rem' }}>{error}</p>
          <button
            onClick={onCancel}
            style={{
              ...styles.button,
              ...styles.buttonPrimary,
              width: '100%'
            }}
          >
            Voltar para o Login
          </button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`
      }}>
        <div style={{
          backgroundColor: colors.white,
          padding: '3rem',
          borderRadius: '1.5rem',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            backgroundColor: '#d1fae5',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem',
            fontSize: '1.5rem'
          }}>
            ✅
          </div>
          <h2 style={{ color: colors.dark, marginBottom: '0.5rem' }}>
            Conta Ativada!
          </h2>
          <p style={{ color: colors.gray }}>
            Senha criada com sucesso! Redirecionando para o login...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`
    }}>
      <div style={{
        backgroundColor: colors.white,
        padding: '3rem',
        borderRadius: '1.5rem',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            width: '60px',
            height: '60px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            fontSize: '1.5rem'
          }}>
            🎯
          </div>
          <h2 style={{ color: colors.dark, marginBottom: '0.5rem' }}>
            Criar Senha
          </h2>
          <p style={{ color: colors.gray }}>
            Crie uma senha para sua conta
          </p>
        </div>
        
        {user && (
          <div style={{
            backgroundColor: colors.grayLight,
            padding: '1rem',
            borderRadius: '0.75rem',
            marginBottom: '1.5rem'
          }}>
            <p style={{ margin: '0.25rem 0', fontSize: '0.875rem' }}>
              <strong>Nome:</strong> {user.nome}
            </p>
            <p style={{ margin: '0.25rem 0', fontSize: '0.875rem' }}>
              <strong>Email:</strong> {user.email}
            </p>
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Nova Senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              style={styles.formInput}
              required
            />
          </div>
          
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Confirmar Senha</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Digite a senha novamente"
              style={styles.formInput}
              required
            />
          </div>
          
          {error && (
            <div style={{
              backgroundColor: '#fee2e2',
              color: '#991b1b',
              padding: '0.75rem',
              borderRadius: '0.5rem',
              fontSize: '0.875rem',
              marginBottom: '1rem'
            }}>
              {error}
            </div>
          )}
          
          <button
            type="submit"
            style={{
              ...styles.button,
              ...styles.buttonPrimary,
              width: '100%',
              marginBottom: '1rem'
            }}
            disabled={loading}
          >
            {loading ? 'Criando senha...' : 'Criar Senha'}
          </button>
          
          <button
            type="button"
            onClick={onCancel}
            style={{
              ...styles.button,
              ...styles.buttonOutline,
              width: '100%'
            }}
          >
            Cancelar
          </button>
        </form>
      </div>
    </div>
  );
};
